import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../../translation/translation_container';
import Select from '../../../../form/floating_label/select';
import Tooltip from '../../../../tooltip/tooltip';
import { getDefaultValueForFilter } from '../../../../../helper/filters/get_default_value_for_filter';

function FilterSelect(props) {
    return (
        <div className="catalog-filter-section__filter">
            <TranslationContainer
                targetProperties={{
                    label: { translationKey: props.labelTranslationKey },
                    provideAllTranslationKey: { translationKey: props.provideAllTranslationKey },
                }}
            >
                <Select
                    name={props.name}
                    label="will-be-replaced"
                    value={props.value}
                    hasValue={getDefaultValueForFilter(props.name) !== props.value}
                    options={props.options}
                    onChange={props.onChange}
                    provideAllOption={props.provideAllOption}
                    disabled={props.disabled}
                    highlight={props.highlight}
                    loading={props.loading}
                    unavailableOptions={props.unavailableOptions}
                />
            </TranslationContainer>

            {props.showTooltip && <Tooltip
                content={props.tooltipContent}
                additionalClassNames={['catalog-filter-section__filter-help']}
                onShowToolTip={props.onToolTipHover}
            />}
        </div>
    );
}

FilterSelect.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    options: PropTypes.array.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
    provideAllTranslationKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    provideAllOption: PropTypes.bool.isRequired,
    onToolTipHover: PropTypes.func,
    tooltipContent: PropTypes.string,
    disabled: PropTypes.bool,
    highlight: PropTypes.bool,
    loading: PropTypes.bool,
    showTooltip: PropTypes.bool,
    unavailableOptions: PropTypes.array,
};

FilterSelect.defaultProps = {
    disabled: false,
    highlight: false,
    loading: false,
    showTooltip: true,
    unavailableOptions: [],
};

export { FilterSelect };
